import GrilleCountComponentController from './grille.count.component.controller';
import Template from './grille.count.component.tpl.html';

export default {
	bindings: {
		domaine: '<',
		id: '<',
		refreshKey: '<'
	},
	template: Template,
	controller: GrilleCountComponentController
};
